export const PAYPAL_HANDLE = "MorganTaylor193";

export const FX_AUD_PER_USD = 1.5;

export type Currency = "USD" | "AUD";

export interface Experience {
  label: string;
  amountUSD: number;
  amountAUD: number;
  icon: string;
  description: string;
}

const baseExperiences = [
  { label: "Warm wishes", amountUSD: 100, icon: "💐", description: "Morning coffee & pastries" },
  { label: "Celebrate the couple", amountUSD: 200, icon: "💖", description: "Cocktails at sunset" },
  { label: "Make a memory", amountUSD: 250, icon: "💌", description: "Romantic dinner for two" },
  { label: "Honeymoon treat", amountUSD: 300, icon: "🎁", description: "Fun activity or excursion" },
  { label: "Custom amount", amountUSD: 0, icon: "💝", description: "Choose your own contribution" },
];

export const experiences: Experience[] = baseExperiences.map(x => ({ 
  ...x, 
  amountAUD: Math.round(x.amountUSD * FX_AUD_PER_USD) 
}));
